import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_PATH } from "../../environment";

const DASHBOARD_BASE_URL = API_BASE_PATH;

interface DashboardCounts {
  tasks: { active_count: number; total: number };
  projects: { active_count: number; total: number };
  attendance: { active_count: number; total: number };
  clients: { total: number };
}

export const useDashboardcount = () => {
  const [dashdata, setData] = useState<DashboardCounts | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = async () => {
    try {
      const response = await axios.get(
        `${DASHBOARD_BASE_URL}/Admindashboard/all-total_dashboard`,
        {
          headers: {
            accept: "application/json",
          },
        }
      );
      setData(response.data.counts);
    } catch (err: any) {
      setError(err.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return { dashdata, isLoading, error };
};

const API_URL = `${DASHBOARD_BASE_URL}/Admindashboard/departments-with-employee-count`;

export const fetchEmpByDepartment = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        accept: "application/json",
      },
    });

    const data = response.data;

    const departmentNames = data.map((item: any) => item.department_name);
    const employeeCounts = data.map((item: any) => item.employee_count);

    return {
      categories: departmentNames,
      series: [
        {
          data: employeeCounts,
          name: "Employee",
        },
      ],
    };
  } catch (error) {
    console.error("Error fetching employee department data:", error);
    return {
      categories: [],
      series: [{ data: [], name: "Employee" }],
    };
  }
};
